import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';

@Component({
  selector: 'app-item-keyword',
  templateUrl: './keyword.component.html',
  styleUrls: ['./keyword.component.scss']
})
export class KeywordComponent implements OnInit {
  @Input() searchParams: SearchCondition;
  @Input() open: boolean;
  last_val = '';

  @Output() newSearch = new EventEmitter<any>();
  constructor() {}

  ngOnInit() {
    this.last_val = this.searchParams.keyword;
  }
  resetSearchkeyword() {
    this.searchParams.keyword = '';
    this.newRequest();
  }

  newRequest() {
    this.last_val = this.searchParams.keyword;

    this.newSearch.next();
  }

  onBlur() {
    if (this.last_val != this.searchParams.keyword) {
      this.newRequest();
    }
  }

  EnterOnSearchBox(event): void {
    if (event.key === 'Enter' && !event.isComposing) {
      event.preventDefault();
      this.newRequest();
    }
  }
}
